module.exports = __webpack_public_path__ + "static/media/main_visual_agriculture_telehandler_mlt_741_140_v_plus_manitou.03582e0c.png";